<template>
  <div class="flex items-center justify-center gap-12 flex-wrap opacity-80">
    <div v-for="integration in integrations" :key="integration.key" class="flex items-center gap-3">
      <div class="w-16 h-10 bg-white rounded flex items-center justify-center p-1 shadow-sm border">
        <img 
          :src="integration.logo" 
          :alt="`${integration.name} logo`"
          class="w-full h-full object-contain"
        />
      </div>
      <span class="text-base font-medium text-gray-700">{{ integration.name }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { integrations } from '@/data/integrations'
</script>